import { render, staticRenderFns } from "./systemMsg.vue?vue&type=template&id=0723956b&scoped=true&"
import script from "./systemMsg.vue?vue&type=script&lang=js&"
export * from "./systemMsg.vue?vue&type=script&lang=js&"
import style0 from "./systemMsg.vue?vue&type=style&index=0&id=0723956b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723956b",
  null
  
)

export default component.exports